import { STATUS } from "@/config/progress";
import { Status } from "@/schema/app/assessment/status";
import AssessmentReportButton from "@/src/app/(auth)/assessment/_components/Header/AssessmentReportButton";
import ImprovementProposalButton from "@/src/app/(auth)/assessment/_components/Header/ImprovementProposalButton";
import ReAssessmentReportButton from "@/src/app/(auth)/assessment/_components/Header/ReAssessmentReportButton";
import SubmitButton from "@/src/app/(auth)/assessment/_components/Header/SubmitButton";

interface ButtonGroupsProps {
  id: number;
  isAllAnswered: boolean;
  status: Status;
  hasImprovementProposal: boolean;
  hasFirstReport: boolean;
  hasSecondReport: boolean;
}

function ButtonGroup({
  id,
  isAllAnswered,
  status,
  hasImprovementProposal,
  hasFirstReport,
  hasSecondReport,
}: ButtonGroupsProps) {
  return (
    <div className="inline-flex items-start justify-start gap-4">
      {status.id < STATUS.SUBMITTED && (
        <SubmitButton disabled={!isAllAnswered} />
      )}
      {(hasFirstReport && status.id >= STATUS.ASSESSMENT_COMPLETED) && (
        <>
          <AssessmentReportButton id={id} />
          {hasImprovementProposal && <ImprovementProposalButton id={id} />}
        </>
      )}
      {hasSecondReport && <ReAssessmentReportButton id={id} />}
    </div>
  );
}

export default ButtonGroup;
